import Axios from "axios";

const API_ROOT: string = "https://websiteservice.careinfosolutions.com/api/";

export default API_ROOT;
//create axios instance
export const instance = Axios.create({
  baseURL: `${API_ROOT}`,
  headers: {
    "Content-Type": "application/json",
  },
});



//get data from api
export const getApiData = async (url: string, param: any = null) => {
  let response;
  try {
    response = await instance({
      method: "GET",
      url: `${url}`,
      params: param,
      transformResponse: [
        function (responseData: any) {
          // Do whatever you want to transform the data
          return JSON.parse(responseData);
        },
      ],
    });
  } catch (e: any) {
    return e.response;
  }
  return response;
};



export { API_ROOT };
